import { render, staticRenderFns } from "./ModalDataPerubahan.vue?vue&type=template&id=eb9feb9a&scoped=true&"
import script from "./ModalDataPerubahan.vue?vue&type=script&lang=js&"
export * from "./ModalDataPerubahan.vue?vue&type=script&lang=js&"
import style0 from "./ModalDataPerubahan.vue?vue&type=style&index=0&id=eb9feb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9feb9a",
  null
  
)

export default component.exports